import axios from 'axios';

const Product = function () {
	
	const onShowNumerClick = () => {
		let links = $('.js-reveal-phone');
		
		links.on('click', function (e) {
			let self = $(this);
			if (!self.hasClass('done')) {
				e.preventDefault();
				$.get(self.attr('href'), function (response) {
					let data = JSON.parse(response);
					if (data.status == 'success') {
						self.html(data.number);
						self.attr('href', data.href);
						self.addClass('done');
					} else {
						alert('Błąd');
					}
				})
			}
		})
	}
	
	const onParameterChange = () => {
		let selects = $(document).find('.product-parameter');
		selects.each(function (i, item) {
			let element = $(item);
			
			element.on("change", function (e) {
				let form = e.target.closest("form");
				let priceUrl = e.target.dataset.priceUrl;
				let paramUrl = e.target.dataset.paramUrl;
				let fd = new FormData(form);
				
				let paramAjax = $.ajax({
					url: paramUrl,
					data: fd,
					processData: false,
					contentType: false,
					type: "post",
				});
				
				let priceAjax = $.ajax({
					url: priceUrl,
					data: fd,
					processData: false,
					contentType: false,
					type: "post",
				});
				
				
				paramAjax.then(function (response) {
					$("#product-parameters").html(response);
					
					onParameterChange();
				});
				
				priceAjax.then(function (response) {
					// let prices = response.split('|');
					// console.log(response);
					let data = JSON.parse(response);
					// console.log(response);
					if (!data.promoPrice) {
						$('#product-price-current').text(data.price);
						$('#product-price-old')[0].style.display = "none";
						$('#product-price-info')[0].style.display = "none";
						$('#product-price-info-price').text("");
					} else {
						$('#product-price-current').text(data.promoPrice);
						$('#product-price-old')[0].style.display = "block";
					}
					
					if (data.promoPrice) {
						$('#product-price-old').text(data.price);
						$('#product-price-old')[0].style.display = "block";
						$('#product-price-info')[0].style.display = "block";
						$('#product-price-info-price').text(data.price);
					}
					
					if (data.installmentValue) {
						$('#js-installment-info').html(data.installmentValue);
					} else {
						$('#js-installment-info').html('');
					}
					
					
					let productContainer = document.querySelector('#js-product-details');
					let productData = productContainer.dataset;
					productData.id = data.item_id;
					productData.variant = data.item_variant;
					productData.price = data.item_price;
					pushViewDetailsToDataLayer(productData);
				});
			});
		});
	};
	
	const onLoad = () => {
		$('.js-item-sizes').each(function () {
			var sizes = $(this);
			var item = sizes.closest('.product-item');
			var size = sizes.find('.product-item__sizes--promotion').first();
			item.find('.js-item-sell-price').html(size.data('price') + ' ' + size.data('currency'));
			item.find('.js-item-old-price').html(size.data('oldprice') + ' ' + size.data('currency'));
			
			if (!size.hasClass('js-item-primary')) {
				item.find('.js-item-link').each(function () {
					var link = $(this);
					link.attr('href', link.attr('href') + size.data('variant'));
				})
			}
		});
	}
	
	const isInViewport = (el, partiallyVisible = false) => {
		const {top, left, bottom, right} = el.getBoundingClientRect();
		const {innerHeight, innerWidth} = window;
		return partiallyVisible
			? ((top > 0 && top < innerHeight) ||
				(bottom > 0 && bottom < innerHeight)) &&
			((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
			: top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
	};
	
	const pushViewDetailsToDataLayer = (data) => {
		let body = document.querySelector('body');
		window.dataLayer = window.dataLayer || [];
		let params = {
			event: 'view_item',
			ecommerce: {
				currency: data.currency,
				value: data.price,
				items: [{
					item_name: data.name,
					item_id: data.id,
					price: data.price,
					item_category: data.category,
					item_variant: data.variant,
					quantity: data.quantity
				}]
			}
		};
		// console.log(params.ecommerce.items[0]);
		window.dataLayer.push(params);
	}
	
	const pushViewToDataLayer = (data) => {
		let body = document.querySelector('body');
		window.dataLayer = window.dataLayer || [];
		let params = {
			event: 'view_item_list',
			ecommerce: {
				item_list_name: data.listname,
				item_list_id: data.listid,
				items: [{
					item_name: data.name,
					item_id: data.id,
					price: data.price,
					item_category: data.category,
					item_variant: data.variant,
					index: data.index,
					currency: data.currency,
					quantity: 1
				}]
			}
		};
		// console.log(params.ecommerce.items[0]);
		window.dataLayer.push(params);
	}
	
	const pushSelectToDataLayer = (data) => {
		let body = document.querySelector('body');
			window.dataLayer = window.dataLayer || [];
			let params = {
				event: 'select_item',
				ecommerce: {
					item_list_name: data.listname,
					item_list_id: data.listid,
					items: [{
						item_name: data.name,
						item_id: data.id,
						price: data.price,
						item_category: data.category,
						item_variant: data.variant,
						index: data.index,
						currency: data.currency,
						quantity: 1
					}]
				}
			};
			// console.log(params.ecommerce.items[0]);
			window.dataLayer.push(params);
	}
	
	const viewListItems = () => {
		let elements = document.querySelectorAll('.product-item');
		if (elements) {
			
			elements.forEach(function (product) {
				let links = product.querySelectorAll('.product-item__link');
				links.forEach(function (link) {
					link.addEventListener('click', function (e) {
						let data = product.dataset;
						pushSelectToDataLayer(data);
					})
				})
				if (!product.classList.contains('gtm')) {
					if (isInViewport(product, true)) {
						let data = product.dataset;
						pushViewToDataLayer(data);
						product.classList.add('gtm');
					}
				}
			});
			
			window.addEventListener('scroll', function (event) {
				elements.forEach(function (product) {
					if (!product.classList.contains('gtm')) {
						if (isInViewport(product, true)) {
							let data = product.dataset;
							pushViewToDataLayer(data);
							product.classList.add('gtm');
						}
					}
				});
			});
		}
	}
	
	const init = () => {
		onLoad();
		onParameterChange();
		onShowNumerClick();
		viewListItems();
		
		let details = document.querySelector('#js-product-details');
		if (details) {
			let force = details.dataset['force'];
			if (force == 1) {
				let firstSelect = document.querySelector('.product-parameter');
				var forceChange = new Event('change');
				firstSelect.dispatchEvent(forceChange);
			}
		}
	};
	
	init();
};

const product = new Product();

export {product};


// WEBPACK FOOTER //
// ../components/products/product/product.js